export function PointDoubleClick(Highcharts) {
    Highcharts.wrap(Highcharts.Chart.prototype, 'firstRender', function (proceed) {
        proceed.call(this);
        const chart = this;
        const container = this.container;
        container.ondblclick = function (e) {
            const hoverPoint = chart.hoverPoint;
            if (hoverPoint) {
                Highcharts.fireEvent(hoverPoint.series, 'dblclick', Highcharts.extend(e, {
                    point: hoverPoint,
                }));
            }
        };
    });
}
//# sourceMappingURL=point-double-click.js.map